// @flow

import * as React from 'react';

import {
  selectCartIsWorking,
  selectCartIsActive,
  type ProductId,
} from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Badge } from '@gandi/ui';

import AlphabetSelect, {
  type Props as AlphabetSelectProps,
} from 'src/Domain/AlphabetSelect';
import { useAppSelector } from 'src/hooks/useAppSelector';

import { ListRow } from '../../../../ListRow';

export type Props = {
  disabledOption: boolean,
  value?: AlphabetSelectProps['value'],
  onChange: AlphabetSelectProps['onChange'],
  /** productId is used to generate a unique field id */
  productId: ProductId,
};

export default function AlphabetRow({
  value,
  onChange,
  disabledOption,
  productId,
}: Props): React.MixedElement {
  const working = useAppSelector(selectCartIsWorking);
  const active = useAppSelector(selectCartIsActive);
  const { __ } = useTranslator();

  const inputId = `alphabet-${productId}`;

  return (
    <ListRow
      intent={value ? 'muted' : 'warning'}
      cta={
        <AlphabetSelect
          id={inputId}
          disabled={disabledOption || working}
          readOnly={!active}
          onChange={onChange}
          value={value}
          big
        />
      }
    >
      {__('Selected alphabet')}
      {!value && (
        <>
          {' '}
          <Badge intent="warning">{__('Missing')}</Badge>
        </>
      )}
    </ListRow>
  );
}
